import { useWatch } from 'react-hook-form';

import { ContextFormFieldSwitch } from 'src/common/FormField/v2/context/ContextFormFieldSwitch';

export function AllowTripConfirmationFormContextField() {
  const allowSmsMessage = useWatch({ name: 'allow_sms_message' });

  return (
    <ContextFormFieldSwitch
      fieldPath="allow_trip_confirmation"
      label="Allow trip confirmation message"
      disabled={!allowSmsMessage}
    />
  );
}
